import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FirmService} from '../services/firm.service';
import {Firms} from '../models/firms';

@Component({
    selector: 'app-firm-menu',
    templateUrl: './firm-menu.component.html',
    styleUrls: ['./firm-menu.component.css']
})
export class FirmMenuComponent implements OnInit {
    private firmId: string;
    public firm: Firms;

    constructor(private router: Router, private firmService: FirmService) {
    }

    ngOnInit() {
        this.firmId = localStorage.getItem('firmId');
        this.getFirm(this.firmId);
    }

    returnUrl() {
        return this.router.url;
    }

    getFirm(firmId: string) {
        if (firmId === null) {
            this.firmService.getFirmsForSuperAdmin().subscribe(res => {
                this.firm = res;
                console.log(this.firm);
            });
        } else {            
            this.firmService.getFirm(firmId).subscribe(res => {
                this.firm = res;
                console.log(this.firm);
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-menu/firm-menu.component.ts